module.exports = __webpack_public_path__ + "static/AzoSans-Medium-632d60a6273139a1926ce9c0b2ce4534.woff2";